export default {
  "Difteria": {
    valor: "Difteria",
  },
  "Tétano": {
    valor: "Tétano",
  },
  "Coqueluche": {
    valor: "Coqueluche",
  },
  "Hepatite A": {
    valor: "Hepatite A",
  },
  "Hepatite B": {
    valor: "Hepatite B",
  },
  "Sarampo": {
    valor: "Sarampo",
  },
  "Caxumba": {
    valor: "Caxumba",
  },
  "Rubéola": {
    valor: "Rubéola",
  },
  "Poliomielite": {
    valor: "Poliomielite",
  },
  "Haemophilus influenzae tipo B (Hib)": {
    valor: "Haemophilus influenzae tipo B (Hib)",
  },
  "Varicela (Catapora)": {
    valor: "Varicela (Catapora)",
  },
  "Gripe (Influenza)": {
    valor: "Gripe (Influenza)",
  },
  "COVID-19": {
    valor: "COVID-19",
  },
  "Febre Amarela": {
    valor: "Febre Amarela",
  },
  "HPV (Papilomavírus Humano)": {
    valor: "HPV (Papilomavírus Humano)",
  },
  "Meningite (meningocócica, pneumocócica)": {
    valor: "Meningite (meningocócica, pneumocócica)",
  },
  "Tuberculose (BCG)": {
    valor: "Tuberculose (BCG)",
  },
  "Rotavírus": {
    valor: "Rotavírus",
  },
  "Vírus Sincicial Respiratório (VSR)": {
    valor: "Vírus Sincicial Respiratório (VSR)",
  },
  "Raiva": {
    valor: "Raiva",
  },
  "Cólera": {
    valor: "Cólera",
  },
  "Febre Tifoide": {
    valor: "Febre Tifoide",
  },
  "Encefalite Japonesa": {
    valor: "Encefalite Japonesa",
  },
  "Herpes Zóster (Cobreiro)": {
    valor: "Herpes Zóster (Cobreiro)",
  },
  "Dengue": {
    valor: "Dengue",
  },
  "Zika": {
    valor: "Zika",
  },
  "Chikungunya": {
    valor: "Chikungunya",
  },
  "Malária": {
    valor: "Malária",
  },
  "Pneumonia": {
    valor: "Pneumonia",
  },
  "Tosse Convulsa": {
    valor: "Tosse Convulsa",
  },
};